import { IFilterSelectVariant } from '@nebo-team-dev/vobaza.ui.filter-select';

export const sortFilterSelectVariants = (values: IFilterSelectVariant[]): IFilterSelectVariant[] => {
  return [...values]?.sort((a, b) => {
    const aValue = a.value?.toString().toLocaleLowerCase();
    const bValue = b.value.toString().toLocaleLowerCase();
    return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
  });
};
